/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from 'react';
import { useStyles } from './ProgressBar.styles';

type ProgressBarProps = {
    progress: number;
    message: string;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({ progress, message }) => {
    const styles = useStyles();

    return (
        <>
            {/* Thin progress bar */}
            <div className={styles.progressBarContainer}>
                <div className={styles.progressBar} style={{ width: `${progress * 100}%` }} />
            </div>
            {/* Progress message */}
            <div className={styles.progressValue}>{message}</div>
        </>
    );
};
